var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f9bb3",
    d: "M14.801 20.5H11.2c-.5 0-.9-.406-.9-.91V12H6.402c-.803 0-1.204-.978-.638-1.555l6.597-6.678a.896.896 0 011.276 0l6.597 6.678c.566.573.165 1.556-.638 1.556h-3.895v7.588a.904.904 0 01-.9.911z"
  }))));
}

export default SvgUp;